import { Alert, AlertTitle, Button } from '@mui/material';
import { useContext } from 'react';
import { ThemeContext } from 'Context/ThemeContext';
import React from 'react';

export default function RestrictionInfo(props) {
  const { title, content, onUpgrade, buttonText = 'Upgrade Plan' } = props;
  const { theme } = useContext(ThemeContext);

  const handleUpgradeClick = () => {
    if (onUpgrade) {
      onUpgrade();
    } else {
      window.dispatchEvent(new CustomEvent('open-plan-price'));
    }
  };

  return (
    <Alert
      severity="warning"
      sx={{
        margin: '14px 0',
        borderRadius: '12px',
        padding: '12px 20px',
        boxShadow: '0 2px 10px rgba(255, 152, 0, 0.15)',
        width: '100%',
        alignItems: 'center',
        '& .MuiAlert-message': {
          width: '100%',
          flex: 1,
          overflow: 'visible',
        },
        '& .MuiAlert-action': {
          alignItems: 'center',
          padding: 0,
          marginLeft: '16px',
        },
      }}
      action={
        <Button
          variant="contained"
          size="medium"
          onClick={handleUpgradeClick}
          sx={{
            backgroundColor: '#1d6df2',
            color: '#ffffff',
            textTransform: 'none',
            fontWeight: 700,
            borderRadius: '50px',
            padding: '8px 22px',
            fontSize: '14px',
            boxShadow: '0 4px 14px rgba(29, 109, 242, 0.35)',
            whiteSpace: 'nowrap',
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: '#1557b0',
            },
          }}
        >
          {buttonText}
        </Button>
      }
    >
      <AlertTitle style={{ marginBottom: 4, fontWeight: 700, fontSize: '15px' }}>
        {title}
      </AlertTitle>
      <div style={{ fontSize: '14px', color: '#4b5563' }}>
        {content} —{' '}
        <strong>
          <a
            target="_blank"
            rel="noreferrer"
            href={`https://api.whatsapp.com/send?phone=${theme?.variable?.phone || ''}&text=Hey%20${theme?.variable?.name || ''},%20Upgrade%20Subscription`}
            style={{ color: '#1d6df2', textDecoration: 'underline' }}
          >
            Contact Us
          </a>
        </strong>
      </div>
    </Alert>
  );
}

